export enum TipoPrecioRetroactivo {
  Todos = 0, 
  Retroactivos = 1, 
  NoRetroactivos = 2
}
